import { useMutation } from '@tanstack/vue-query'

import { useUsersService } from '~/core/services'
import type { DTO, FetchErrorObj, Nullable } from '~/core/types'
import type { PatchUsersDTO, User } from '~/core/types/users'

export const useUserStore = defineStore('user', () => {
  const { displayToast } = useUiStore()
  const { getUser, patchUser } = useUsersService()

  const user = ref<Nullable<FetchResult<User>>>(null)
  const fetched = ref<boolean>(false)

  const { mutateAsync: getUserAsync, mutate } = useMutation<Nullable<FetchResult<User>>>({
    mutationFn: getUser,
    onSuccess: (res) => {
      user.value = res
    },
    onSettled: () => {
      fetched.value = true
    },
  })

  const { mutate: updateUser, isPending, error, mutateAsync: updateUserAsync } = useMutation<Nullable<FetchResult<User>>, FetchErrorObj<DTO<PatchUsersDTO>>, DTO<PatchUsersDTO>>({
    mutationFn: (p: DTO<PatchUsersDTO>) => patchUser(p),
    onSuccess: (res) => {
      user.value = res
      displayToast('Votre compte a été mis à jour avec succès', 'success', 2000)
    },
    onError: (err) => {
      displayToast(err.message, 'error', 2000)
    },
  })

  const isLogged = computed(() => (user.value?.data ?? null) !== null)

  return {
    user,
    fetched,
    isLogged,
    getUserAsync,
    updateUserAsync,
    getUser: mutate,
    updateUser,
    isPending,
    error,
  }
})
